import { compose } from "redux";
import classNames from "classnames";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import React, { PureComponent, createRef } from "react";

import { Grid, RootRef, Typography, ButtonBase } from "@material-ui/core";

import { toggleDeploymentDetailsModal } from "features/planner/planner.actions";

class Deployment extends PureComponent {
  constructor(props) {
    super(props);

    this.root = createRef();

    this.state = {
      rootClientHeight: undefined,
    };
  }

  componentDidMount() {
    const { count } = this.props;

    if (this.root.current && count > 1) {
      this.setState({
        rootClientHeight: this.root.current.clientHeight,
      });
    }
  }

  componentDidUpdate(prevProps) {
    const { count } = this.props;

    if (count === 1) {
      this.setState({
        rootClientHeight: undefined,
      });
    }

    if (this.root.current && prevProps.count > 1) {
      this.setState({
        rootClientHeight: this.root.current.clientHeight,
      });
    }
  }

  toggleDeploymentDetailsModal = () => {
    const {
      deploymentDetail,
      dispatchToggleDeploymentDetailsModal,
    } = this.props;

    dispatchToggleDeploymentDetailsModal(deploymentDetail);
  };

  render() {
    const { classes, deploymentDetail } = this.props;

    const title =
      deploymentDetail.get("groupShortName") ||
      deploymentDetail.get("groupName");

    return (
      <RootRef rootRef={this.root}>
        <Grid
          xs
          item
          container
          title={title}
          justifyContent="center"
          alignItems="center"
          component={ButtonBase}
          onClick={this.toggleDeploymentDetailsModal}
          className={classNames(
            classes.availabilityOverride,
            classes.deployment,
          )}
        >
          <Typography
            noWrap
            variant="caption"
            color="secondary"
            className={classes.overrideTitle}
            style={{
              fontSize: this.state.rootClientHeight,
              lineHeight: `${this.state.rootClientHeight}px`,
            }}
          >
            {title}
          </Typography>
        </Grid>
      </RootRef>
    );
  }
}

const styles = theme => ({
  availabilityOverride: {
    borderRadius: 2,
    zIndex: theme.zIndex.availabilityOverride,
    overflow: "hidden",
    "&:not(:last-child)": {
      marginBottom: 1,
    },
  },
  overrideTitle: {
    fontWeight: theme.typography.fontWeightMedium,
  },
  deployment: {
    borderRadius: 2,
    background: theme.altus.calendar.deploymentColor.main,
    "&:hover": {
      background: theme.altus.calendar.deploymentColor.hover,
    },
  },
});

export default compose(
  connect(null, {
    dispatchToggleDeploymentDetailsModal: toggleDeploymentDetailsModal,
  }),
  withStyles(styles),
)(Deployment);
